import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start";
import { createRouter } from "./router";

import { ToastContainer, Bounce } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";
const router = createRouter();

hydrateRoot(
  document,
  <HelmetProvider>
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      transition={Bounce}
    />
    <StartClient router={router} />
  </HelmetProvider>
);
